import type { DataScreenTranslate } from '@smartsash/data-screen';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import type { TranslationKey } from '@/types/i18n';

/**
 * The `useTranslate` seam every admin data-screen definition injects (HS-869).
 *
 * `@smartsash/data-screen` carries no i18n runtime and no user-facing copy: it takes keys and asks
 * the app to resolve them. The cast is the boundary — the package's key type is `string` because it
 * cannot know an app's catalogue, while admin's `t` is typed against `en.json`. A key that does not
 * exist therefore renders as itself rather than failing typecheck, which is why every key a
 * definition passes must also be added to both locale files.
 */
export function useDataScreenTranslate(): DataScreenTranslate {
  const { t } = useTranslation();
  return useCallback((key: string) => t(key as TranslationKey), [t]);
}
